import { ViewExportSchema } from "@redotech/redo-views-common/view-exports";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const watchViewExportProgress = unaryStreamRpc({
  name: "watchViewExportProgress",
  input: z.object({ viewExportIds: z.array(z.string()) }),
  output: z.object({ viewExport: ViewExportSchema }),
});
